import React from "react";
import { SealCheck } from "@phosphor-icons/react";

/**
 * Jobs IQ "Verified" badge.
 * Shown when avg AI match ≥ 80 and seeker has ≥ 3 applications.
 */
export const VerifiedBadge = ({ size = "sm", tone = "light", testId = "verified-badge" }) => {
    const px = size === "lg" ? 18 : size === "md" ? 14 : 12;
    const cls =
        tone === "dark"
            ? "bg-blue-600 text-white"
            : tone === "outline"
              ? "border border-blue-600 text-blue-600"
              : "bg-blue-50 text-blue-700 border border-blue-200";
    const padding = size === "lg" ? "px-2.5 py-1" : "px-2 py-0.5";
    const text = size === "lg" ? "text-xs" : "text-[10px]";
    return (
        <span
            data-testid={testId}
            className={`inline-flex items-center gap-1 font-mono-plex ${text} uppercase tracking-widest ${cls} ${padding}`}
            title="Verified by Jobs IQ — avg AI match ≥ 80 across 3+ applications"
        >
            <SealCheck size={px} weight="fill" /> Verified by Jobs IQ
        </span>
    );
};

export default VerifiedBadge;
